/*
 * @Author       : yilei
 * @Date         : 2023-03-07 16:42:47
 * @LastEditTime : 2025-01-07 11:52:10
 * @LastEditors  : zhouxiaojian
 */
import { getCookie } from './cookie'

if (window.AJKFELOG && !window.ajklog) {
  window.ajklog = new window.AJKFELOG.AJKLOG({
    appId: '9c930d89-6278-4be2-9360-95ff2bf4cae1',
    userId: getCookie('ajk_member_id'),
    ssid: getCookie('xxzlclientid'),
    guid: getCookie('aQQ_ajkguid'),
    grayConfig: {
      all: true,
      userWhiteList: [],
      urlWhiteList: []
    },
    immediate: true,
    behaviorLength: 3,
    builder: ['baseBuilder', 'behaviourBuilder']
  })
  // 增加伪登陆标识
  window.ajklog.builder.use(function (log: any, data: any) {
    data.ep.fakeLogin = getCookie('fakeLogin')
    return data
  })
  // window.ajklog = new window.AJKFELOG.AJKLOG({
  //   appId: '9c930d89-6278-4be2-9360-95ff2bf4cae1',
  //   userId: getCookie('ajk_member_id'),
  //   ssid: getCookie('xxzlclientid'),
  //   guid: getCookie('aQQ_ajkguid'),
  //   whileList: [
  //     // '/threenets/mix/price/appeal', // 三网-价格申诉
  //     // '/solar/mix/price/appeal', // 门店-价格申诉
  //     // '/threenets/mix/price/appeal/detail', // 三网-价格申诉详情
  //     // '/solar/mix/price/appeal/detail', // 门店-价格申诉详情
  //     // '/solar/muggle-marketing/list/solar/mix/price/appeal', // 巧房-价格申诉
  //     // '/solar/muggle-marketing/list/solar/mix/price/appeal/detail'  // 巧房-价格申诉详情
  //     // '/threenets/mix/second-hand/list__sl', // 三网-全部房源-房源库
  //     // '/threenets/mix/second-hand/illegal-list__sl', // 三网-全部房源-违规房源
  //     // '/threenets/mix/second-hand/draft-list__sl', // 三网-全部房源-草稿箱
  //     // '/threenets/mix/second-hand/detail', // 三网-房源单页
  //     // '/threenets/mix/second-hand/second-hand-house', // 三网-房源发布、房源编辑
  //     // '/solar/mix/second-hand/second-hand-house__mw', // 门店-房源编辑
  //     '/solar/mix/companyhouse/list', // 门店-公司房源-二手房列表
  //     // '/solar/mix/companyhouse/houseDetailInfo__hl', // 门店-公司房源-二手房详情
  //     // '/threenets/venus/new-house/agency-new-house', // 发布新房
  //     // '/threenets/venus/correction/correct-community__mw', // 小区纠错
  //     // '/threenets/venus/correction/correct-housenumber__mw', // 房源纠错
  //     // '/solar/metis/mendian' // 门店首页
  //     '/solar/mix/report/42457713' // 在线带看报表
  //   ],
  //   immediate: true,
  //   behaviorLength: 3
  // })
}

function ajklogInit () {
  // window.ajklog && window.ajklog.init()
}

export { ajklogInit }
